import documentosConsorcio from "./consorcios";

export default { ...documentosConsorcio };
